import React from 'react'
import './Footer.css'

const Footer = () => {
  return (
   <>
    <section className="end">
      <div className="last-text">
        <p>
          <i className="bx bx-code-alt"></i> with ❤ by Iman Bachat © 2023
        </p>
      </div>
      <div className="top">
        <a href="#home"><i className="bx bx-up-arrow-alt"></i></a>
      </div>
    </section>

   </>
  )
}

export default Footer